import { ColorEnum } from '@/constants/color'
import { FC, ReactNode } from 'react'
import { StyleProp, StyleSheet, ViewStyle } from 'react-native'
import Animated from 'react-native-reanimated'

interface SheetProps {
    children: ReactNode
    style?: StyleProp<ViewStyle>
}

const Sheet: FC<SheetProps> = ({ children, style }) => {
    return <Animated.View style={[styles.container, style]}>{children}</Animated.View>
}

const styles = StyleSheet.create({
    container: {
        backgroundColor: ColorEnum.VIOLET_100,
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        width: '100%',
        marginTop: 'auto',
        zIndex: 2,
    },
})

export default Sheet
